import { Timestamp } from "api/firebase";

export enum BackgroundTaskStatus {
  CREATED = "CREATED",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export interface IBackgroundTask {
  commonOperationId: string;
  operationId: string;
  status: BackgroundTaskStatus;
  message: null | string;
  stack: null | string;
  timestamp: Timestamp;
}
